import { Link, NavLink } from "react-router-dom";
import { Moon, Sun, Layers, Upload, History, Brain, FlaskConical } from "lucide-react";

const NAV = [
  { to: "/", label: "Studio", icon: Upload, testid: "nav-studio" },
  { to: "/playground", label: "Playground", icon: FlaskConical, testid: "nav-playground" },
  { to: "/verlauf", label: "Verlauf", icon: History, testid: "nav-history" },
  { to: "/quiz", label: "Quiz", icon: Brain, testid: "nav-quiz" },
];

export function Header({ dark, toggleTheme }) {
  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-50 border-b border-slate-200/80 dark:border-slate-800/80 bg-white/85 dark:bg-[#0B0F17]/85 backdrop-blur-md"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-3 group shrink-0" data-testid="header-logo-link">
          <span className="grid place-items-center h-9 w-9 rounded-lg bg-[#0F2942] dark:bg-blue-600 text-white shadow-sm">
            <Layers className="h-5 w-5" />
          </span>
          <div className="leading-tight hidden sm:block">
            <div className="font-display font-extrabold tracking-tight text-slate-900 dark:text-slate-100">
              Karteikarten<span className="text-blue-600 dark:text-blue-400">·Studio</span>
            </div>
          </div>
        </Link>

        <nav className="flex items-center gap-1 rounded-xl border border-slate-200 dark:border-slate-700 p-1 bg-white/60 dark:bg-slate-900/60">
          {NAV.map(({ to, label, icon: Icon, testid }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              data-testid={testid}
              className={({ isActive }) =>
                `inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-[#0F2942] dark:bg-blue-600 text-white"
                    : "text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800"
                }`
              }
            >
              <Icon className="h-4 w-4" />
              <span className="hidden sm:inline">{label}</span>
            </NavLink>
          ))}
        </nav>

        <button
          data-testid="theme-toggle-button"
          onClick={toggleTheme}
          aria-label="Design wechseln"
          className="h-9 w-9 grid place-items-center rounded-lg border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors shrink-0"
        >
          {dark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        </button>
      </div>
    </header>
  );
}
